import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { Link, Route, withRouter, Switch, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import CaseInformation from "./CaseInformation";
import Award from "./Award";
import DocsList from "./DocsList";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";
import PrimaryAppBar from "../../components/PrimaryAppBar";
import withSizes from "react-sizes";

import Footer from "../Footer/Footer";

import MainPanelHome from "./MainPanelHome";

const styles = (theme) => ({
  isMobileFormControl: {
    marginLeft: "auto",
    marginRight: "auto",
  },
  active_tabStyle: {
    color: "white",
    backgroundColor: "#B71C1C",
    outline: "0",
  },
  root: {
    width: "100vw",
    '@media (max-width: 576px)': {
        width: '100%'
    }
  },
  [theme.breakpoints.down("xs")]: {
    tabLabel: {
      fontSize: 12,
    },
  },
  [theme.breakpoints.up("sm")]: {
    tabLabel: {
      fontSize: 12,
    },
  },
  [theme.breakpoints.up("md")]: {
    tabLabel: {
      fontSize: 12,
    },
  },
  btn: {
    marginBottom: "10px",
  },
  btnimg: {
    width: "100%",
  },
  gri: {},
});

function TabContainer(props) {
  return <Typography component="div">{props.children}</Typography>;
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

function LinkTab(props) {
  return <Tab component={Link} {...props} />;
}

class MainPanelRoute extends Component {
  state = {
    tab: "",
    value: undefined,
    typeOfAccount: localStorage.getItem("typeOfAccount"),
    windowHeight: undefined,
    windowWidth: undefined,
  };

  handleResize = () => {
    this.setState({
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    });
  };

  componentDidUpdate() {}

  checkLanguage = function() {
    // try{
    //   if (this.props.isLoading){
    //     setTimeout(()=>{this.checkLanguage()},100)
    //   }
    //   else{
    //     console.log('this caseData: '+JSON.stringify(this.props.caseData))
    //     var lang = localStorage.getItem('language');
    //     if (this.props !== undefined){
    //       if (this.props.caseData !== undefined){
    //         if (this.props.caseData.language !== undefined){
    //           if (this.props.caseData.language == 'Chi'){
    //             if (lang == 'en' || lang == undefined){
    //               localStorage.setItem('language', 'cn');
    //               setTimeout(()=>{
    //                   window.location.reload();
    //               },100)
    //             }
    //           }
    //           else if (this.props.caseData.language == 'Eng'){
    //             if (lang == 'cn' || lang == undefined){
    //               localStorage.setItem('language', 'en');
    //               setTimeout(()=>{
    //                   window.location.reload();
    //               },100)
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // }catch(err){
    //   setTimeout(()=>{this.checkLanguage()},100)
    // }
  };

  componentDidMount() {
    console.log(
      "localStorage.getItem(caseId): " + localStorage.getItem("caseId")
    );
    console.log(
      "localStorage.getItem(token): " + localStorage.getItem("token")
    );

    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    this.props.getCaseInfo(
      localStorage.getItem("caseId"),
      localStorage.getItem("token")
    );
    this.props.getUserInformation(localStorage.getItem("token"));
    this.checkLanguage();
  }

  componentWillMount() {
    window.removeEventListener("resize", this.handleResize);
    // console.log('localStorage.getItem(caseId): '+localStorage.getItem('caseId'))
    // console.log('localStorage.getItem(token): '+localStorage.getItem('token'))
    this.props.getCaseInfo(
      localStorage.getItem("caseId"),
      localStorage.getItem("token")
    );
    this.props.getUserInformation(localStorage.getItem("token"));
  }

  handleChange = (event, value) => {
    console.log(`FM handleChange value ${value}`);
    this.setState({ value });
    if (value === 3) {
      this.props.history.push(`${this.props.match.url}/uploadDocument`);
    } else if (value === 6) {
      this.props.history.push(`${this.props.match.url}/award`);
    } else if (value === 0) {
      this.props.history.push(`${this.props.match.url}/caseInfo`);
    } else if (value === undefined) {
      this.props.history.goBack();
    }
  };

  handleChangeSelect = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { classes, history, location, match } = this.props;
    const { value } = this.state;

    return (
      <>
        <Switch>
          <Route
            path={`${match.url}/uploadDocument`}
            render={(routeProps) => (
              <>
                <div className={classes.root}>
                <PrimaryAppBar />
                <DocsList
                  handleChange={this.handleChange}
                  caseData={this.props.caseData}
                  docs={{
                    claimant_docs: this.props.claimant_docs,
                    respondent_docs: this.props.respondent_docs,
                  }}
                  showUploadDocs={this.props.userType === "All"}
                  match={this.props.match}
                  history={this.props.history}
                />
                <Footer />
                </div>
              </>
            )}
          />
          <Route
            path={`${match.url}/award`}
            render={(routeProps) => (
              <div className={classes.root}>
                <PrimaryAppBar />
                <Award
                  handleChange={this.handleChange}
                  caseData={this.props.caseData}
                  docs={{
                    claimant_docs: this.props.claimant_docs,
                    respondent_docs: this.props.respondent_docs,
                  }}
                  showUploadDocs={this.props.userType === "All"}
                  match={this.props.match}
                  history={this.props.history}
                />
                <Footer />
                </div>
            )}
          />
          <Route
            path={`${match.url}/caseInfo`}
            render={(routeProps) => (
              <div className={classes.root}>
                <PrimaryAppBar />
                <CaseInformation
                  handleChange={this.handleChange}
                  caseData={this.props.caseData}
                  docs={{
                    claimant_docs: this.props.claimant_docs,
                    respondent_docs: this.props.respondent_docs,
                  }}
                  showUploadDocs={this.props.userType === "All"}
                  match={this.props.match}
                  history={this.props.history}
                />
                <Footer />
                </div>
            )}
          />
          <Route
            path={`${match.url}`}
            render={(routeProps) => (
              <div className={classes.root}><MainPanelHome
                isLoading={this.props.isLoading}
                classes={classes}
                newAccount={this.props.newAccount}
                typeOfAccount={this.state.typeOfAccount}
                isMobile={this.props.isMobile}
                windowWidth={this.state.windowWidth}
                handleChange={this.handleChange}
                value={this.state.value}
                lang={this.props.lang}
                caseData={this.props.caseData}
                isDesktop={this.props.isDesktop}
                claimant_docs={this.props.claimant_docs}
                respondent_docs={this.props.respondent_docs}
                userType={this.props.userType}
                match={this.props.match}
                history={this.props.history}
              /></div>
            )}
          />
        </Switch>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    isLoading: state.userInfo.isLoading,
    userId: state.auth.userId,
    respondent_docs: state.caseInfo.respondent_docs,
    arbitrator_docs: state.caseInfo.arbitrator_docs,
    claimant_docs: state.caseInfo.claimant_docs,
    caseId: state.caseInfo.caseId,
    userType: state.caseInfo.userType,
    caseData: state.caseInfo.caseData,
    lang: state.i18nState.lang,
    newAccount: state.caseInfo[`${state.caseInfo.userType}_newAccount`],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCaseInfo: (caseId, uniqueId) =>
      dispatch(actions.getCaseInfo(caseId, uniqueId)),
    getUserInformation: (uniqueId) =>
      dispatch(actions.getUserInformation(uniqueId)),
  };
};

const mapSizesToProps = (sizes) => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet: withSizes.isTablet(sizes),
  isDesktop: withSizes.isDesktop(sizes),
  isGtMobile: withSizes.isGtMobile(sizes),
  isGtTablet: withSizes.isGtTablet(sizes),
  isStTablet: withSizes.isStTablet(sizes),
  isStDesktop: withSizes.isStDesktop(sizes),
  isTabletAndGreater: withSizes.isTabletAndGreater(sizes),
  isTabletAndSmaller: withSizes.isTabletAndSmaller(sizes),
});

MainPanelRoute.contextTypes = {
  t: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSizes(mapSizesToProps)(withStyles(styles)(withRouter(MainPanelRoute))));
